<template>
  <div :class="['example-title', 'mb-16']">
    <div :class="['vc-table-layout']">
      <div>
        <div>
          <h3 :class="['title', 'font-grey', 'font-l-600', 'ellipsis', 'pa-8']" v-html="title" />
        </div>
        <div :class="['align-right']" v-if="src">
          <vc-button v-if="src" size="small" color="grey l-700" icon-left="code" @click="click">Get Code</vc-button>
          <vc-button v-if="url" tag="a" :to="url" size="small" color="grey l-700" target="_blank">
            <vc-icon>link</vc-icon>
          </vc-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import methods from '../../helpers/methods'

export default {
  name: 'ExampleTitle',
  mixins: [
    methods
  ],
  props: {
    title: {
      type: String,
      required: true
    },
    src: {
      type: String,
      required: false
    },
    url: {
      type: String,
      required: false
    }
  },
  methods: {
    click () {
      this.sendGaEvent('Demos', 'get code', this.title)
      this.$root.$emit(this.$store.state.events.showCodeDialog, {
        src: this.src,
        title: this.title
      })
    }
  }
}
</script>
<style>
.example-title
{
  border-bottom: dotted 1px #bdbdbd;
}

.example-title .align-right
{
  width: 170px;
  white-space: nowrap;
}

.example-title .vc-button
{
  margin-left: 0;
}

.example-title a.vc-button
{
  min-width: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/example-title/ExampleTitle.vue